import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Feedback from './Feedback.jsx';
import Loading from '../Loading';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/feedbacksActions';
import ServerError from '../ServerError';
import moment from 'moment';
import Modal from '../Modal/Modal.js';
import { DebounceInput } from 'react-debounce-input';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getRole } from '../../utils/token.js';
import GOOD from '../../assets/img/rating/good.png';
import BAD from '../../assets/img/rating/bad.png';
import NEUTRAL from '../../assets/img/rating/neutral.png';
import config from 'react-global-configuration';
import { request } from './../../sagas/index';
import { rqStatusEnum } from "../../constants/global";

export class FeedbackList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query: 'react',
      showReactionDialog: false,
      showDeleteReactionDialog: false,
      reaction: '',
      isAnonymizationModalShown: false,
      anonymizationRqStatus: rqStatusEnum.default,
      anonymizationResponse: {
        passed: 0,
        failed: 0,
      }
    };
  }

  loadFeedbacks = () => {
    const settings = {
      page: this.props.page,
      paging: this.props.paging,
      sortDirection: this.props.sortDirection,
      sortBy: this.props.sortBy,
      filter: this.props.filter,
      dateFrom: this.props.dateFrom,
      dateTo: this.props.dateTo,
      categories: this.props.categories,
      withComment: this.props.withComment,
      withReaction: this.props.withReaction,
      rating: this.props.rating,
      country: this.props.country,
      createdBySkodaEmployee: this.props.createdBySkodaEmployee,
    };
    this.props.actions.loadFeedbacks(settings);
  }

  componentDidMount() {
    this.loadFeedbacks()
    this.props.actions.loadCategories();
  }

  componentDidUpdate() {
    if (this.props.file) {
      const url = window.URL.createObjectURL(this.props.file);
      const link = document.createElement('a');
      link.href = url;
      const fileName = this.props.attachment
        ? this.props.attachment
        : 'export-' +
          moment().format('YYYY-MM-DD.') +
          (this.props.file.type === 'text/csv' ? 'csv' : 'xlsx');
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      this.props.actions.resetFile();
    }
  }

  changeSort = (current) => {
    if (current === 'ASC') {
      return 'DESC';
    }
    return 'ASC';
  };

  exportFeedbacks = (type) => {
    const settings = {
      type: type,
      sortBy: this.props.sortBy,
      sortDirection: this.props.sortDirection,
      filter: this.props.filter,
      categories: this.props.selectedCategories,
      dateFrom: this.props.dateFrom,
      dateTo: this.props.dateTo,
      withComment: this.props.withComment,
      withReaction: this.props.withReaction,
      rating: this.props.rating,
      country: this.props.country,
      createdBySkodaEmployee: this.props.createdBySkodaEmployee,
    };
    this.props.actions.downloadFeedbacks(settings);
  };

  downloadAttachment = (attachment) => {
    this.props.actions.downloadFeedbacksAttachment(attachment);
  };

  editCategory = (feedbackId, categoryCode) => {
    this.setState({
      editedCategory: feedbackId,
      newCategory: categoryCode,
    });
  };

  cancelCategory = () => {
    this.setState({
      editedCategory: '',
    });
  };

  changeCategory = (newCategory) => {
    this.setState({
      newCategory: newCategory,
    });
  };

  updateCategory = () => {
    this.props.actions.updateCategory(
      this.state.editedCategory,
      this.state.newCategory
    );
    this.setState({
      editedCategory: '',
    });
  };

  selectComment = () => {
    const withComment =
      this.props.withComment === true
        ? false
        : this.props.withComment === false
          ? null
          : true;
    const settings = {
      page: 0,
      paging: this.props.paging,
      sortBy: this.props.sortBy,
      sortDirection: this.props.sortDirection,
      filter: this.props.filter,
      categories: this.props.selectedCategories,
      dateFrom: this.props.dateFrom,
      dateTo: this.props.dateTo,
      withComment: withComment,
      withReaction: this.props.withReaction,
      rating: this.props.rating,
      country: this.props.country,
      createdBySkodaEmployee: this.props.createdBySkodaEmployee,
    };
    this.props.actions.loadFeedbacks(settings);
    const myUrlWithParams = new URL(window.location.href);
    if (settings.withComment !== null) {
      myUrlWithParams.searchParams.set('page', 0);
      myUrlWithParams.searchParams.set('withComment', settings.withComment);
    } else {
      myUrlWithParams.searchParams.delete('withComment');
    }
    const url = myUrlWithParams.pathname + myUrlWithParams.search;
    this.props.history.replace(url);
  };

  selectReaction = () => {
    const withReaction =
      this.props.withReaction === true
        ? false
        : this.props.withReaction === false
          ? null
          : true;
    const settings = {
      page: 0,
      paging: this.props.paging,
      sortBy: this.props.sortBy,
      sortDirection: this.props.sortDirection,
      filter: this.props.filter,
      categories: this.props.selectedCategories,
      dateFrom: this.props.dateFrom,
      dateTo: this.props.dateTo,
      withComment: this.props.withComment,
      withReaction: withReaction,
      rating: this.props.rating,
      country: this.props.country,
      createdBySkodaEmployee: this.props.createdBySkodaEmployee,
    };
    this.props.actions.loadFeedbacks(settings);
    const myUrlWithParams = new URL(window.location.href);
    if (settings.withReaction !== null) {
      myUrlWithParams.searchParams.set('page', 0);
      myUrlWithParams.searchParams.set('withReaction', settings.withReaction);
    } else {
      myUrlWithParams.searchParams.delete('withReaction');
    }
    const url = myUrlWithParams.pathname + myUrlWithParams.search;
    this.props.history.replace(url);
  };

  selectCategory = (selected) => {
    const categories = [];
    selected.map((category) => categories.push(category.value));
    const settings = {
      page: 0,
      paging: this.props.paging,
      sortBy: this.props.sortBy,
      sortDirection: this.props.sortDirection,
      filter: this.props.filter,
      categories: categories.length > 0 ? categories : null,
      dateFrom: this.props.dateFrom,
      dateTo: this.props.dateTo,
      withComment: this.props.withComment,
      withReaction: this.props.withReaction,
      rating: this.props.rating,
      country: this.props.country,
      createdBySkodaEmployee: this.props.createdBySkodaEmployee,
    };
    this.props.actions.loadFeedbacks(settings);
    const myUrlWithParams = new URL(window.location.href);
    if (settings.categories !== null) {
      myUrlWithParams.searchParams.set('page', 0);
      myUrlWithParams.searchParams.delete('categories');
      settings.categories.forEach((category) =>
        myUrlWithParams.searchParams.append('categories', category)
      );
    } else {
      myUrlWithParams.searchParams.delete('categories');
    }
    const url = myUrlWithParams.pathname + myUrlWithParams.search;
    this.props.history.replace(url);
  };

  sendToCask = (feedbackId) => {
    this.props.actions.sendToCask(feedbackId);
  };

  addReaction = (feedbackId) => {
    this.setState({
      showReactionDialog: true,
      feedbackId: feedbackId,
      oldReaction: false,
      newReaction: '',
    });
  };

  editReaction = (feedbackId, reaction) => {
    this.setState({
      showReactionDialog: true,
      feedbackId: feedbackId,
      oldReaction: true,
      newReaction: reaction,
    });
  };

  cancelFeedback = () => {
    this.setState({
      showReactionDialog: false,
      showDeleteReactionDialog: false,
      showDeleteFeedbackDialog: false,
    });
  };

  saveReaction = () => {
    this.props.actions.saveReaction(
      this.state.feedbackId,
      this.state.newReaction
    );
    this.setState({
      showReactionDialog: false,
    });
  };

  handleReactionChange = (event) => {
    this.setState({ newReaction: event.target.value });
  };

  deleteReaction = (feedbackId, reaction) => {
    this.setState({
      showDeleteReactionDialog: true,
      feedbackId: feedbackId,
      newReaction: reaction,
    });
  };

  deleteFeedback = (feedbackId) => {
    this.setState({
      showDeleteFeedbackDialog: true,
      feedbackId: feedbackId,
    });
  };

  confirmDeleteReaction = () => {
    this.props.actions.deleteReaction(this.state.feedbackId);
    this.setState({
      showDeleteReactionDialog: false,
    });
  };

  confirmDeleteFeedback = () => {
    this.props.actions.deleteFeedback(this.state.feedbackId);
    this.setState({
      showDeleteFeedbackDialog: false,
    });
  };

  showAnonymizationModal = () => {
    this.setState({
      isAnonymizationModalShown: true,
      anonymizationRqStatus: rqStatusEnum.default
    })
  }

  hideAnonymizationModal = () => {
    this.setState({
      isAnonymizationModalShown: false
    })
  }

  reloadFeedbacks = (e) => {
    const { paging, sortBy, filter, dateFrom, dateTo } = this.props;
    let { page, sortDirection, rating } = this.props;
    if (
      e.target.name === 'feedbackTable_length' ||
      e.target.name === 'feedbackTable_filter'
    ) {
      page = 0;
    }
    if (
      e.target.id.startsWith('sort_by_') &&
      e.target.id.substring(8) === sortBy
    ) {
      sortDirection = this.changeSort(sortDirection);
    } else if (
      e.target.id.startsWith('sort_by_') &&
      e.target.id.substring(8) !== sortBy
    ) {
      sortDirection = 'ASC';
    }
    if (e.target.id.startsWith('rating-')) {
      const newRating = e.target.id.substring(7);
      if (rating === newRating) {
        rating = null;
      } else {
        rating = newRating;
      }
    }
    const settings = {
      page:
        e.target.name === 'feedbackTable_page'
          ? e.target.id.substring(4)
          : page,
      paging:
        e.target.name === 'feedbackTable_length' ? e.target.value : paging,
      sortBy: e.target.id.startsWith('sort_by_')
        ? e.target.id.substring(8)
        : sortBy,
      sortDirection: sortDirection,
      filter:
        e.target.name === 'feedbackTable_filter' ? e.target.value : filter,
      categories: this.props.selectedCategories,
      dateFrom:
        e.target.id === 'dateFrom'
          ? !!e.target.value
            ? e.target.value
            : null
          : dateFrom,
      dateTo:
        e.target.id === 'dateTo'
          ? !!e.target.value
            ? e.target.value
            : null
          : dateTo,
      withComment: this.props.withComment,
      withReaction: this.props.withReaction,
      rating: rating,
      country: this.props.country,
      createdBySkodaEmployee: this.props.createdBySkodaEmployee,
    };
    this.props.actions.loadFeedbacks(settings);
    const myUrlWithParams = new URL(window.location.href);
    myUrlWithParams.searchParams.set('page', settings.page);
    myUrlWithParams.searchParams.set('paging', settings.paging);
    myUrlWithParams.searchParams.set('sortBy', settings.sortBy);
    myUrlWithParams.searchParams.set('sortDirection', settings.sortDirection);
    if (settings.filter) {
      myUrlWithParams.searchParams.set('filter', settings.filter);
    } else {
      myUrlWithParams.searchParams.delete('filter');
    }
    if (settings.dateFrom) {
      myUrlWithParams.searchParams.set('dateFrom', settings.dateFrom);
    } else {
      myUrlWithParams.searchParams.delete('dateFrom');
    }
    if (settings.dateTo) {
      myUrlWithParams.searchParams.set('dateTo', settings.dateTo);
    } else {
      myUrlWithParams.searchParams.delete('dateTo');
    }
    if (settings.categories) {
      myUrlWithParams.searchParams.set('categories', settings.categories);
    } else {
      myUrlWithParams.searchParams.delete('categories');
    }
    if (settings.rating) {
      myUrlWithParams.searchParams.set('rating', settings.rating);
    } else {
      myUrlWithParams.searchParams.delete('rating');
    }
    const url = myUrlWithParams.pathname + myUrlWithParams.search;
    this.props.history.replace(url);
  };

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      anonymizationRqStatus: rqStatusEnum.default
    });
  }

  emailSubmitHandle = async () => {
    if(this.state.emailToAnonymize) {
      this.setState({ anonymizationRqStatus: rqStatusEnum.inProgress });
      try {
        const response = await request(`${config.get('connectGWEndpoint')}api/v1/feedbacks/anonymize`, {
          method: 'POST',
          type: 'application/json',
          body: JSON.stringify({email: this.state.emailToAnonymize}),
        })
        if (response && response.passed && response.failed) {
          this.setState({
            anonymizationRqStatus: rqStatusEnum.success,
            anonymizationResponse: {
              failed: response.failed.length || 0,
              passed: response.passed.length || 0,
            }
          });
          this.loadFeedbacks()
        } else {
          this.setState({ anonymizationRqStatus: rqStatusEnum.error });
        }
      } catch (e) {
        console.error(e)
        this.setState({ anonymizationRqStatus: rqStatusEnum.error });
      }
    }
  }

  render() {
    const { intl } = this.props;
    const role = getRole();

    if (this.props.error) {
      return <ServerError error={this.props.error} />;
    }
    return (
      <main role="main" className="container-fluid">
        <div className="my-3 p-3 bg-white rounded shadow-sm small">
          <div className="row">
            <div className="col-sm-12">
              <button
                className="btn btn-info btn-sm"
                onClick={() =>
                  this.exportFeedbacks({
                    content:
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    format: 'xlsx',
                  })
                }
              >
                <FormattedMessage
                  id="app.feedback.export.excel"
                  defaultMessage="export"
                />
              </button>
              &nbsp;
              <button
                className="btn btn-info btn-sm"
                onClick={() =>
                  this.exportFeedbacks({ content: 'text/csv', format: 'csv' })
                }
              >
                <FormattedMessage
                  id="app.feedback.export.csv"
                  defaultMessage="export"
                />
              </button>
              {role === config.get('adminRole') && (
                <>
                  &nbsp;
                  <button className="btn btn-info btn-sm" onClick={this.showAnonymizationModal}>
                    <FormattedMessage
                      id="app.feedback.anonymize"
                      defaultMessage="Anonymize"
                    />
                  </button>
                  {this.state.isAnonymizationModalShown &&(
                    <Modal
                      closeFunction={this.hideAnonymizationModal}
                      closeLabel={intl.formatMessage({
                        id: 'app.feedback.reaction.button.cancel',
                      })}
                      className={this.state.anonymizationRqStatus === rqStatusEnum.inProgress ? 'loading' : null}
                    >
                      <div className={'row row--align-items-end'}>
                        <div className={'col'}>
                          <label>
                            <FormattedMessage id={'app.feedback.email'} defaultMessage="e-mail" />
                          </label>
                          <input
                            className={'form-control form-control-sm'}
                            list={'user-emails-list'}
                            type={'email'}
                            name={'emailToAnonymize'}
                            autoComplete={'off'}
                            onChange={this.handleInputChange}
                            autoFocus
                          />
                        </div>
                        <div className={'col col-auto'}>
                          <button
                            className={'btn btn-sm btn-info'}
                            onClick={this.state.emailToAnonymize ? this.emailSubmitHandle : null}
                            disabled={!this.state.emailToAnonymize ||
                              this.state.anonymizationRqStatus === rqStatusEnum.inProgress ||
                              this.state.anonymizationRqStatus === rqStatusEnum.success
                            }
                          >
                            <FormattedMessage
                              id="app.feedback.submit"
                              defaultMessage="Submit"
                            />
                          </button>
                        </div>
                      </div>
                      <datalist id={'user-emails-list'}>
                        {[...new Set(this.props.feedbackList
                          .filter(item => item.user.email !== 'ANONYMIZED')
                          .map(item => item.user.email))]
                          .map(item => (<option value={item} key={item} />))}
                      </datalist>
                      {this.state.anonymizationRqStatus === rqStatusEnum.success && (
                        <div style={{ marginTop: '5px' }}>
                          <FormattedMessage
                            id={'app.feedback.anonymization.success'}
                            defaultMessage={'User anonymization was successful.'}
                          />
                          {' '}
                          <FormattedMessage
                            id={'app.feedback.passed'}
                            defaultMessage={'Passed'}
                          />
                          : {this.state.anonymizationResponse.passed || 0}.
                          {' '}
                          <FormattedMessage
                            id={'app.feedback.failed'}
                            defaultMessage={'Failed'}
                          />
                          : {this.state.anonymizationResponse.failed || 0}.
                        </div>
                      )}
                      {this.state.anonymizationRqStatus === rqStatusEnum.error && (
                        <FormattedMessage
                          id={'app.feedback.anonymization.error'}
                          defaultMessage={'An error occurred while anonymizing user. Try again later.'}
                        />
                      )}
                    </Modal>
                  )}
                </>)}
            </div>
          </div>
          <br />
          <div
            id="feedbackTable_wrapper"
            className="dataTables_wrapper dt-bootstrap4 no-footer"
          >
            <div className="row">
              <div className="col-sm-12 col-md-2">
                <div className="dataTables_length" id="feedbackTable_length">
                  <label>
                    <FormattedMessage
                      id="app.feedback.show.1"
                      defaultMessage="show"
                    />
                    &nbsp;
                    <select
                      name="feedbackTable_length"
                      aria-controls="feedbackTable"
                      className="custom-select custom-select-sm form-control form-control-sm"
                      onChange={this.reloadFeedbacks}
                      value={this.props.paging}
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>{' '}
                    <FormattedMessage
                      id="app.feedback.show.2"
                      defaultMessage="show"
                    />
                  </label>
                </div>
              </div>
              <div
                className="col-sm-12 col-md-2"
                style={{ transform: 'translateY(-7px)' }}
              >
                <div
                  id="rating-GOOD"
                  className={`ratingSelection ${
                    this.props.rating === 'GOOD' ? 'selectedRating' : ''
                  }`}
                  onClick={this.reloadFeedbacks}
                >
                  <img className="mt-1" src={GOOD} width="30" alt={''} />
                </div>
                <div
                  id="rating-NEUTRAL"
                  className={`ratingSelection ${
                    this.props.rating === 'NEUTRAL' ? 'selectedRating' : ''
                  }`}
                  onClick={this.reloadFeedbacks}
                >
                  <img className="mt-1" src={NEUTRAL} width="30" alt={''} />
                </div>
                <div
                  id="rating-BAD"
                  className={`ratingSelection ${
                    this.props.rating === 'BAD' ? 'selectedRating' : ''
                  }`}
                  onClick={this.reloadFeedbacks}
                >
                  <img className="mt-1" src={BAD} width="30" alt={''} />
                </div>
              </div>
              <div className="col-sm-12 col-md-2">
                <div id="feedbackTable_dateFrom" className="dataTables_filter">
                  <label>
                    <FormattedMessage id="app.feedback.dateFrom" />:
                    <input
                      id="dateFrom"
                      type="date"
                      className="form-control form-control-sm"
                      onChange={this.reloadFeedbacks}
                      value={this.props.dateFrom}
                    />
                  </label>
                </div>
              </div>
              <div className="col-sm-12 col-md-2">
                <div id="feedbackTable_dateTo" className="dataTables_filter">
                  <label>
                    <FormattedMessage id="app.feedback.dateTo" />:
                    <input
                      id="dateTo"
                      type="date"
                      className="form-control form-control-sm"
                      onChange={this.reloadFeedbacks}
                      value={this.props.dateTo}
                    />
                  </label>
                </div>
              </div>
              <div className="col-sm-12 col-md-2">
                <div id="feedbackTable_filter" className="dataTables_filter">
                  <label>
                    <FormattedMessage id="app.feedback.search" />:
                    <FormattedMessage id="app.feedback.search">
                      {(message) => (
                        <DebounceInput
                          name="feedbackTable_filter"
                          type="search"
                          value={this.props.filter}
                          className="form-control form-control-sm"
                          placeholder={message}
                          debounceTimeout={300}
                          onChange={this.reloadFeedbacks}
                        />
                      )}
                    </FormattedMessage>
                  </label>
                </div>
              </div>
            </div>
            {this.renderFeedbacks(role)}
            {this.state.showReactionDialog && (
              <Modal
                header={intl.formatMessage({
                  id:
                    'app.feedback.reaction.header.' +
                    (this.state.oldReaction ? 'edit' : 'add'),
                })}
                closeFunction={() => this.cancelFeedback()}
                closeLabel={intl.formatMessage({
                  id: 'app.feedback.reaction.button.cancel',
                })}
                confirmFunction={() => this.saveReaction()}
                confirmLabel={intl.formatMessage({
                  id:
                    'app.feedback.reaction.button.' +
                    (this.state.oldReaction ? 'edit' : 'add'),
                })}
              >
                <div className="my-3 p-3 bg-white rounded shadow-sm">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 font-weight-bold">
                      <FormattedMessage id="app.feedback.reaction.text" />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-12">
                      <textarea
                        className="form-control"
                        name="adminResponse"
                        rows="6"
                        style={{
                          marginTop: '0px',
                          marginBottom: '0px',
                          height: '224px',
                        }}
                        value={this.state.newReaction}
                        onChange={(e) => this.handleReactionChange(e)}
                      />
                    </div>
                  </div>
                </div>
              </Modal>
            )}
            {this.state.showDeleteReactionDialog && (
              <Modal
                header={intl.formatMessage({
                  id: 'app.feedback.confirmation.header',
                })}
                closeFunction={this.cancelFeedback}
                closeLabel={intl.formatMessage({
                  id: 'app.feedback.dialog.button.no',
                })}
                confirmFunction={this.confirmDeleteReaction}
                confirmLabel={intl.formatMessage({
                  id: 'app.feedback.dialog.button.yes',
                })}
              >
                <div>
                  <FormattedMessage id="app.feedback.delete.reaction.confirmation.message" />
                  <em>{this.state.newReaction}</em>
                </div>
              </Modal>
            )}
            {this.state.showDeleteFeedbackDialog && (
              <Modal
                header={intl.formatMessage({
                  id: 'app.feedback.confirmation.header',
                })}
                closeFunction={this.cancelFeedback}
                closeLabel={intl.formatMessage({
                  id: 'app.feedback.dialog.button.no',
                })}
                confirmFunction={this.confirmDeleteFeedback}
                confirmLabel={intl.formatMessage({
                  id: 'app.feedback.dialog.button.yes',
                })}
              >
                <div>
                  <FormattedMessage id="app.feedback.delete.feedback.confirmation.message" />
                </div>
              </Modal>
            )}
          </div>
        </div>
      </main>
    );
  }

  renderFeedbacks(role) {
    if (this.props.loading) {
      return <Loading />;
    }
    return (
      <Feedback
        count={this.props.count}
        total={this.props.total}
        page={this.props.page}
        paging={this.props.paging}
        sortBy={this.props.sortBy}
        sortDirection={this.props.sortDirection}
        feedbackList={this.props.feedbackList}
        reload={this.reloadFeedbacks}
        filter={this.props.filter}
        addReaction={this.addReaction}
        editReaction={this.editReaction}
        deleteReaction={this.deleteReaction}
        deleteFeedback={this.deleteFeedback}
        role={role}
        categories={this.props.categoryList}
        editCategory={this.editCategory}
        changeCategory={this.changeCategory}
        updateCategory={this.updateCategory}
        cancelCategory={this.cancelCategory}
        editedCategory={this.state.editedCategory}
        newCategory={this.state.newCategory}
        sendToCask={this.sendToCask}
        downloadAttachment={this.downloadAttachment}
        selectedCategories={this.props.selectedCategories}
        selectCategory={this.selectCategory}
        withComment={this.props.withComment}
        selectComment={this.selectComment}
        withReaction={this.props.withReaction}
        selectReaction={this.selectReaction}
        intl={this.props.intl}
      />
    );
  }
}

FeedbackList.propTypes = {
  actions: PropTypes.object.isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool,
  count: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  paging: PropTypes.number.isRequired,
  sortBy: PropTypes.string,
  sortDirection: PropTypes.string,
  filter: PropTypes.string,
  dateFrom: PropTypes.string,
  dateTo: PropTypes.string,
  categories: PropTypes.array,
  withComment: PropTypes.bool,
  withReaction: PropTypes.bool,
  rating: PropTypes.string,
  country: PropTypes.string,
  createdBySkodaEmployee: PropTypes.bool,
  feedbackList: PropTypes.array,
  categoryList: PropTypes.array,
  history: PropTypes.object,
  file: PropTypes.object,
  attachment: PropTypes.string,
  selectedBookmark: PropTypes.string,
};

function mapStateToProps(state) {
  const myUrlWithParams = new URL(window.location.href);
  const page = parseInt(myUrlWithParams.searchParams.get('page'));
  const paging = parseInt(myUrlWithParams.searchParams.get('paging'));
  const sortBy = myUrlWithParams.searchParams.get('sortBy');
  const sortDirection = myUrlWithParams.searchParams.get('sortDirection');
  const filter = myUrlWithParams.searchParams.get('filter');
  const dateFrom = myUrlWithParams.searchParams.get('dateFrom');
  const dateTo = myUrlWithParams.searchParams.get('dateTo');
  const selectedCategories = myUrlWithParams.searchParams.getAll('categories');
  const withComment = myUrlWithParams.searchParams.get('withComment')
    ? myUrlWithParams.searchParams.get('withComment') === 'true'
    : null;
  const withReaction = myUrlWithParams.searchParams.get('withReaction')
    ? myUrlWithParams.searchParams.get('withReaction') === 'true'
    : null;
  const rating = myUrlWithParams.searchParams.get('rating');
  const selectedBookmark = myUrlWithParams.searchParams.get('bookmark');
  const createdBySkodaEmployee =
    selectedBookmark === 'skoda'
      ? true
      : selectedBookmark === 'main'
        ? undefined
        : false;
  return {
    loading: state.feedbacks.loading,
    error: state.feedbacks.error,
    count: state.feedbacks.count,
    total: state.feedbacks.total,
    page: page ? page : state.feedbacks.page,
    paging: paging ? paging : state.feedbacks.paging,
    sortBy: sortBy ? sortBy : state.feedbacks.sortBy,
    sortDirection: sortDirection
      ? sortDirection
      : state.feedbacks.sortDirection,
    filter: filter ? filter : state.feedbacks.filter,
    selectedCategories:
      selectedCategories.length > 0
        ? selectedCategories
        : state.feedbacks.selectedCategories,
    dateFrom: dateFrom ? dateFrom : state.feedbacks.dateFrom,
    dateTo: dateTo ? dateTo : state.feedbacks.dateTo,
    withComment:
      withComment !== null ? withComment : state.feedbacks.withComment,
    withReaction:
      withReaction !== null ? withReaction : state.feedbacks.withReaction,
    rating: rating ? rating : state.feedbacks.rating,
    feedbackList: state.feedbacks.feedbackList,
    categoryList: state.feedbacks.categories,
    file: state.feedbacks.file,
    attachment: state.feedbacks.attachment,
    selectedBookmark: selectedBookmark
      ? selectedBookmark
      : state.feedbacks.selectedBookmark,
    country:
      selectedBookmark &&
      selectedBookmark !== 'main' &&
      selectedBookmark !== 'skoda'
        ? selectedBookmark
        : state.feedbacks.country,
    createdBySkodaEmployee: createdBySkodaEmployee,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(FeedbackList));
